<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><span>{{ $t('company.roles') }}</span></li>
				</ul>
			</div>
		</div>


		<div id="roles_toolbar" class="toolbar">
			<button id="roles_table_toolbar_add" :title="$t('create')">
				<span uk-icon="plus"></span>
				<span class="title">{{ $t('create') }}</span>
			</button>
			<button id="roles_table_toolbar_remove" :title="$t('delete')">
				<span uk-icon="trash"></span>
				<span class="title">{{ $t('delete') }}</span>
			</button>
		</div>

		<div class="table_search_phrase">
			<div id="phase" class="uk-search uk-search-default">
				<a class="uk-search-icon-flip" uk-search-icon></a>
				<input class="uk-search-input uk-form-small" type="text" :placeholder="$t('search')">
				<span class="search_reset fa fa-times" tabindex="-1"></span>
			</div>
		</div>

		<div class="row table-area-row">
			<div class="col-sm-12 table-area-col">
				<table id="table" class="table"></table>
			</div>
		</div>

		<div class="row">
			<div class="col-sm-12">
				<div class="row">
					<div class="table-footer">
						<div class="col-xs-6 col-sm-3">
							<div id="status-bar" class="status-bar"></div>
						</div>
						<div class="col-xs-12 col-sm-6">
							<div id="pager" class="pager"></div>
						</div>
						<div class="col-sm-3">
							<div id="pagerSize" class="page-sizer-container"></div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div id="context-menu" class="context-menu">
			<ul class="dropdown-menu" role="menu">
				<li><a tabindex="-1">
					{{ $t('edit.company.roles') }}
				</a></li>
				<li><a tabindex="-1">
					{{ $t('remove.company.roles') }}
				</a></li>
			</ul>
		</div>
	</div>
</template>

<script>
import { USER_CONFIG } from 'actions/user'
import { CompanyRolesManager } from '@/core/administration/CompanyRolesManager'
import { resizeTableHeight, Table, toggleSearchForm } from '@/core/support_gui_components/table/table'
import { getLocalizedMessage, removeTabindex, showMessageAlert } from '@/core/shared'
import { bindResetButton } from '@/core/input_controls/button/button'
import { setToolbarMode } from '@/core/support_gui_components/table/table_toolbar'
import { initFilterForm } from '@/core/filters/filtersSupport'
import { enableMulticheckboxSupport } from '@/core/input_controls/multicheckbox/multicheckbox'
import { enableHotkeyForSearch } from '@/core/hotkey/HotkeyFunctions'

export default {
	name: 'CompanyRoles',
	metaInfo () {
		return {
			title: this.$t('company.roles')
		}
	},
	props: [
		'id',
		'admin'
	],
	mounted () {
		let tableColumns = [
			{
				'checkbox': true
			},
			{
				'title': 'name',
				'columnName': 'name',
				'attribute': 'name'
			},
			{
				'title': 'description',
				'columnName': 'description',
				'attribute': 'description'
			},
			{
				'title': 'global',
				'columnName': 'global_localized',
				'attribute': 'global'
			}
		]

		window.itemStructure = {
			'phase': { 'type': 'S' }
		}

		let permissions = [{
			'id': 1,
			'code': 'ROLE_EDIT_ITEM',
			'name': 'Insert/edit item'
		}, {
			'id': 4,
			'code': 'ROLE_EXPORT',
			'name': 'Export'
		}, {
			'id': 5,
			'code': 'ROLE_IMPORT',
			'name': 'Import'
		}, {
			'id': 6,
			'code': 'ROLE_EXPORT_IMPORT_CONFIGURATION',
			'name': 'Manage configuration for export/import'
		}, {
			'id': 7,
			'code': 'ROLE_MANAGER',
			'name': 'Company manager'
		}, {
      'id': 8,
      'code': 'ROLE_DELETE_ITEM',
      'name': 'Delete item'
    }]

		let companyId = this.id || this.$store.getters.getProfile.companyId

		window.manager = new CompanyRolesManager()

		this.$store.dispatch(USER_CONFIG, 'rolesTable.tableState')
			.then((config) => {
				window.table = new Table('rolesTable', {
						selector: '#table',
						columns: tableColumns,
						dynamicLoading: true,
						contextMenu: '#context-menu',
						doubleClickMode: 'edit',
						sortingSupport: true,
						cellsSelectionsSupport: true,
						itemsSelectionsSupport: true,
						frozenFirstColumn: true,
						restoringSupport: true,
						filterPreProcessor: function (filter) {
							var newFilter = {}
							for (var fieldName in filter) {
								newFilter[fieldName] = filter[fieldName]['val']
							}
							return newFilter
						}
					},
					{
						contextMenu: {
							1: function (item, attribute) {
								if (item.companyId === null) {
									showMessageAlert('Global roles can be edited only on administration page', 'warning')
									return
								}
								initUserGroupManager('edit', item, attribute)
							},
							2: function (item) {
								if (item.companyId === null) {
									showMessageAlert('Global roles can be deleted only on administration page', 'warning')
									return
								}
								manager.initRemoveUserGroupManager(item)
							}
						},
						doubleClick: {
							'edit': function (item, table) {
								table.callbacks.contextMenu['1'](item, table.selectedAttribute)
							}
						}
					},
					function (data) {
						_.each(data, function (value) {
							value.global_localized = getLocalizedMessage(value.companyId === null)
						})
					})
				table.setSavedState(config)
				table.setDataUrl(window.urlContext + 'company/' + companyId + '/roles/load')
				table.setDataIDsUrl(window.urlContext + 'company/' + companyId + '/roles/ids')
				table.setDataSortUrl(window.urlContext + 'company/' + companyId + '/roles/sort')
				table.initTable()

				bindResetButton()
				removeTabindex()

				setToolbarMode(table.selectedItemsMode)
				initFilterForm(itemStructure, table)
				enableMulticheckboxSupport({ selector: '.multicheckbox-filter' })
				enableHotkeyForSearch(itemStructure, table)
			})
			.catch(error => {
				console.log(error)
				this.rollbar.error('USER_CONFIG RolesTable', error)
			})

		// toolbar buttons
		$('#table_toolbar_search').bind('click', toggleSearchForm)
		$('#roles_table_toolbar_add').click(function () {
			initUserGroupManager('create', { companyId: companyId }, '')
		})
		$('#roles_table_toolbar_remove').bind('click', function () {
			var ids = table.selectedItemsManager.getSelections()
			if (_.isEmpty(ids)) {
				showMessageAlert('No selected roles', 'warning')
			} else {
				manager.initRemoveGroupsManager(ids)
			}
		})

		function initUserGroupManager (action, item, activeAttribute) {
			manager.setProperties({
				action: action,
				roleId: item.id,
				activeAttribute: activeAttribute,
				companyId: item.companyId,
				userGroup: item || {},
				allPermissions: permissions || [],
				rolePermissions: null,
				saveButton: '#company_save-user-role',
				postSaveAction: function () {
					table.initTable()
				}
			})
			manager.openUserGroupModal(action)
		}

		$(window).resize(function () {
			resizeTableHeight()
			table.frozenTableElements.setFrozenHeaderCellsWidth()
			table.frozenTableElements.setFrozenColumnCellsHeight()
		})
	}
}
</script>

<style scoped>

</style>
